import React from 'react';
import styled from 'styled-components';
import Banner from './Banner';
import Store from './Store';

const MainWrapper = styled.div`
  box-sizing: border-box;
  padding: 0 22.5rem;

  @media screen and (max-width: 1199px) {
    padding: 0;
    border-bottom: none;
  }
`;

const Main = ({ store, keyword, typename }) => {
  return (
    <MainWrapper>
      <Banner />
      <Store store={store} keyword={keyword} typename={typename} />
    </MainWrapper>
  );
};

export default Main;
